import { Button } from '@heidi/design-system/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@heidi/design-system/dialog';
import { Link } from '@heidi/design-system/link';
import { useIntl } from 'react-intl';

const TERMS_OF_USE_URL =
  'https://www.heidihealth.com/en-au/legal/heidi-scribe-terms-of-use';
const USAGE_POLICY_URL = 'https://www.heidihealth.com/en-au/legal/scribe-usage-policy';
const PRIVACY_POLICY_URL = 'https://www.heidihealth.com/en-au/legal/privacy-policy';

interface NonAuTermsModalProps {
  open: boolean;
  onProceed: () => void;
}

export const NonAuTermsModal = ({ open, onProceed }: NonAuTermsModalProps) => {
  const intl = useIntl();

  return (
    <Dialog open={open}>
      <DialogContent
        hideCloseIcon
        dismissible={false}
        overlayClassName="backdrop-blur-sm"
        onEscapeKeyDown={(e) => e.preventDefault()}
        
      >
        <DialogHeader>
          <DialogTitle>
            {intl.formatMessage({
              defaultMessage: 'Accept terms of use',
              id: 'jY666Pn31G',
            })}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {intl.formatMessage(
            {
              defaultMessage:
                "By proceeding, you will gain access to the Heidi platform and agree that your use of the Heidi platform is subject to Heidi's <terms>Terms of Use</terms>, <privacy>Privacy Policy</privacy> and <policy>Usage Policy</policy>.",
              id: 'F12QWO+Lk3',
            },
            {
              terms: (chunks) => (
                <Link
                  href={TERMS_OF_USE_URL}
                  variant="inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </Link>
              ),
              policy: (chunks) => (
                <Link
                  href={USAGE_POLICY_URL}
                  variant="inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </Link>
              ),
              privacy: (chunks) => (
                <Link
                  href={PRIVACY_POLICY_URL}
                  variant="inline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </Link>
              ),
            }
          )}
        </DialogDescription>
        <DialogFooter>
          <Button size="lg" onClick={onProceed}>
            {intl.formatMessage({
              id: 'VNX4fn4oTB',
              defaultMessage: 'Agree',
            })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
